// CMS Page Routes

import Home from "../Pages/Home";
import AboutUs from "../Pages/AboutUs";
import AboutUsApp from "../Pages/AboutUsApp";
import Organisation from "../Pages/Organisation";
import Partnerships from "../Pages/Partnerships";
import PartnershipsApp from "../Pages/PartnershipsApp";
import Faq from "../Pages/Faq";
import FaqApp from "../Pages/FaqApp";
import ContactUs from "../Pages/ContactUs";
import Mentors from "../Pages/Mentors";
import MentorIgnite from "../Pages/MentorIgnite";
import Cms from "../Pages/CMS";
import Program from "../Pages/Program";
//Auth Routes
import Login from "../Pages/Authentication/SignIn";
import ForgotPassword from "../Pages/Authentication/ForgotPassword";
import RestPassword from "../Pages/Authentication/RestPassword";
import Register from "../Pages/Authentication/Register";
import StudentSignUp from "../Pages/StudentSignUp/StudentSignup";
import StudentSignUp2 from "../Pages/StudentSignUp/StudentSignup2";
import StudentSignUp3 from "../Pages/StudentSignUp/StudentSignup3";
import StudentSignUp4 from "../Pages/StudentSignUp/StudentSignup4";
import MentorSignUp from "../Pages/MentorSignUp/MentorSignUp";
import MentorSignUp2 from "../Pages/MentorSignUp/MentorSignUp2";
import MentorSignUp3 from "../Pages/MentorSignUp/MentorSignUp3";
import MentorSignUp4 from "../Pages/MentorSignUp/MentorSignUp4";

// After login
import MentorListing from "../Pages/MentorListing";
import MenteeListing from "../Pages/MenteeListing";
import Dashboard from "../Pages/Dashboard";
import CurrentMentees from "../Pages/MentorDashboard1";
import SuggestedMentor from "../Pages/MenteeDashboard";
import UpdateProfile from "../Pages/UpdateProfile/UpdateProfile1";
import UpdateProfile2 from "../Pages/UpdateProfile/UpdateProfile2";
import UpdateProfile3 from "../Pages/UpdateProfile/UpdateProfile3";
import UpdateProfile4 from "../Pages/UpdateProfile/UpdateProfile4";
import Password from "../Pages/Password";
import MenteeRequest from "../Pages/MenteesRequest";
import MyMentors from "../Pages/MyMentors";
import MyWaitList from "../Pages/MyWaitList/index";
import PendingMenterRequest from "../Pages/PendingMenterRequest";
import MenteesLog from "../Pages/MenteesLog";
import Availability from "../Pages/Availability";
import Chat from "../Pages/Chat";
import Resourcehub from "../Pages/Resourcehub/ResourcesHub";
import PostResourcehub from "../Pages/Resourcehub/PostResourcesHub";
import ResourcesDetail from "../Pages/ResourcesDetail";
import DeleteProfile from "../Pages/DeleteProfile/DeleteProfile";
import CommunityDetail from "../Pages/CommunityDetail";
import MyDiagnosticToolkit from "../Pages/MyDiagnosticToolkit";
import Refer from "../Pages/Refer";
import Forum from "../Pages/Forum";
import ForumTest from "../Pages/Forum/forumtest";
import CKEditorFileUpload from "../Pages/CKEditorFileUpload";

//Events
import Event from "../Pages/Event";
import EventDetail from "../Pages/Event/detail";
import Newsletter from "../Pages/Resourcehub/Newsletter";
import NewsletterApp from "../Pages/Resourcehub/NewsletterApp";
import Videos from "../Pages/Resourcehub/Video";
import PreRegistrationFrom from "../Pages/PreRegistrationFrom";
import Certificate from "../Pages/Certificate";
import ScheduleListingCalendar from "../Pages/ScheduleListingCalendar"
import updateProfile12 from "../Pages/UpdateProfile/updateProfile12";
import FusionAuthCallback from "../Pages/FusionAuthCallback";
import OAuthRedirect from "../Component/Header/OAuthRedirect";
import SSORouteProtection from "../utils/SSORouteProtection";





export const routeArr = [
  {
    path: "/mentors",
    name: "Mentors",
    component: Mentors,
    title: "Mentors",
    slug: 'Mentoring Engagement'
  },
  {
    path: "/oauth/callback",
    name: "fussionAuthCallback",
    component: FusionAuthCallback,
    title: "fussionAuthCallback",
    slug: 'Mentoring Engagement'
  },
  {
    path: "/oauth-redirect",
    name: "fussionAuth",
    component: OAuthRedirect,
    title: "fussionAuth",
    slug: 'O Auth Redirect'
  },

  // {
  //   path: "*",
  //   name: "Mentors",
  //   component: NotFound,
  //   title: "Not Found",
  //   slug:'Not Found'
  // },
  {
    path: "/partnerships",
    name: "partnerships",
    component: Partnerships,
    title: "Partnerships",
    slug: 'Home Page Content'
  },
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUs,
    title: " Helping women grow and lea",
    slug: 'Site Content'
  },
  {
    path: "/resource-hub/:slug",
    name: "Resourcehub",
    component: Resourcehub,
    title: "Resourcehub",
    slug: 'Resource Hub'
  },
  {
    path: "/resource-hub",
    name: "Resourcehub",
    component: Resourcehub,
    title: "Resourcehub",
    slug: 'Resource Hub'

  },
  {
    path: "/resources-details/:slug",
    name: "ResourcesDetail",
    component: ResourcesDetail,
    title: "ResourcesDetail",
    slug: 'Resource Hub'

  },
  {
    path: "/resources-details",
    name: "Resourcehub",
    component: Resourcehub,
    title: "Resourcehub",
    slug: 'Resource Hub'

  },
  {
    path: "/community-details/:slug",
    name: "CommunityDetail",
    component: CommunityDetail,
    title: "CommunityDetail",
    slug: 'Communities'
  },
]

export const RoutesPage = [
  { path: "/", name: "Home", component: Home, title: "vLookUp" },

  {
    path: "/ignite-women-mentoring",
    name: "Mentors",
    component: MentorIgnite,
    title: "Mentors",
  },

  {
    path: "/organisations",
    name: "organisations",
    component: Organisation,
    title: "Partners and Organisations",
  },
  {
    path: "/faq",
    name: "Faq",
    component: Faq,
    title: "FAQ's",
  },


  {
    path: "/contact-us",
    name: "Contact Us",
    component: ContactUs,
    title: "Contact Us",
  },

  {
    path: "/newsletter",
    name: "Newsletter",
    component: Newsletter,
    title: "Newsletter",
  },
  {
    path: "/videos",
    name: "Video",
    component: Videos,
    title: "Video",
  },
  {
    path: "/post-resource-hub",
    name: "PostResourcehub",
    component: PostResourcehub,
    title: "PostResourcehub",
  },

  {
    path: "/page/:slug",
    name: "PrivacyPolicy",
    component: Cms,
    title: "Privacy Policy",
  },
  {
    path: "/uploader/upload",
    name: "FileUpload",
    component: CKEditorFileUpload,
    title: "File Upload",
  },
  {
    path: "/event/:type",
    name: "Event",
    component: Event,
    title: "Event",
  },
  {
    path: "/event-detail/:slug",
    name: "EventDetail",
    component: EventDetail,
    title: "Event Detail",
  },
];

export const RoutesAuth = [
  {
    path: "/login",
    name: "Login",
    component: (props) => (
      <SSORouteProtection>
        <Login {...props} />
      </SSORouteProtection>
    ),
    title: "Login",
  },
  {
    path: "/register",
    name: "Register",
    component: (props) => (
      <SSORouteProtection>
        <Register {...props} />
      </SSORouteProtection>
    ),
    title: "Register",
  },
  {
    path: "/aboutusapp",
    name: "AboutUsApp",
    component: AboutUsApp,
    title: "About Us",
  },
  {
    path: "/faqapp",
    name: "faqapp",
    component: FaqApp,
    title: "FAQ's",
  },
  {
    path: "/partnershipsapp",
    name: "partnershipsapp",
    component: PartnershipsApp,
    title: "Partnerships",
  },
  {
    path: "/program",
    name: "Program",
    component: Program,
    title: "Program",
  },

  {
    path: "/newsletterapp/:slug",
    name: "NewsletterApp",
    component: NewsletterApp,
    title: "Newsletter",
  },
  {
    path: "/registration-step-1",
    name: "StudentSignUp",
    component: (props) => (
      <SSORouteProtection>
        <StudentSignUp {...props} />
      </SSORouteProtection>
    ),
    title: "StudentSignUp",
  },
  {
    path: "/registration-step-2",
    name: "StudentSignUp step 2",
    component: (props) => (
      <SSORouteProtection>
        <StudentSignUp2 {...props} />
      </SSORouteProtection>
    ),
    title: "StudentSignUp step 2",
  },
  {
    path: "/registration-step-3",
    name: "StudentSignUp step 3",
    component: (props) => (
      <SSORouteProtection>
        <StudentSignUp3 {...props} />
      </SSORouteProtection>
    ),
    title: "StudentSignUp step 3",
  },
  {
    path: "/registration-step-4",
    name: "StudentSignUp4",
    component: (props) => (
      <SSORouteProtection>
        <StudentSignUp4 {...props} />
      </SSORouteProtection>
    ),
    title: "StudentSignUp4",
  },

  {
    path: "/mentor-signup-step-1",
    name: "MentorSignUp",
    component: (props) => (
      <SSORouteProtection>
        <MentorSignUp {...props} />
      </SSORouteProtection>
    ),
    title: "MentorSignUp",
  },
  {
    path: "/mentor-signup-step-2",
    name: "MentorSignUp step 2",
    component: (props) => (
      <SSORouteProtection>
        <MentorSignUp2 {...props} />
      </SSORouteProtection>
    ),
    title: "MentorSignUp step 2",
  },
  {
    path: "/mentor-signup-step-3",
    name: "MentorSignUp step 3",
    component: (props) => (
      <SSORouteProtection>
        <MentorSignUp3 {...props} />
      </SSORouteProtection>
    ),
    title: "MentorSignUp step 3",
  },
  {
    path: "/mentor-signup-step-4",
    name: "MentorSignUp4",
    component: (props) => (
      <SSORouteProtection>
        <MentorSignUp4 {...props} />
      </SSORouteProtection>
    ),
    title: "MentorSignUp4",
  },

  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: (props) => (
      <SSORouteProtection>
        <ForgotPassword {...props} />
      </SSORouteProtection>
    ),
    title: "Forgot Password",
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: (props) => (
      <SSORouteProtection>
        <ForgotPassword {...props} />
      </SSORouteProtection>
    ),
    title: "Forgot Password",
  },
  {
    path: "/reset-password",
    name: "Rest Password",
    component: (props) => (
      <SSORouteProtection>
        <RestPassword {...props} />
      </SSORouteProtection>
    ),
    title: "Rest Password",
  },
  {
    path: "/pre-registration-form",
    name: "Pre Registration From",
    component: PreRegistrationFrom,
    title: "Pre Registration From",
  },
];

export const RoutesUser = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    title: "Dashboard",
  },
  {
    path: "/current-mentees",
    name: "CurrentMentees",
    component: CurrentMentees,
    title: "Current Mentees",
  },
  // {
  //   path: "/schedule-meeting",
  //   name: "ScheduleListing",
  //   component: ScheduleListing,
  //   title: "Schedule Listing",
  // },
  {
    path: "/schedule-meeting-calendar",
    name: "ScheduleListingCalendar",
    component: ScheduleListingCalendar,
    title: "Calendar/Meetings",
  },
  {
    path: "/suggested-mentors",
    name: "SuggestedMentor",
    component: SuggestedMentor,
    title: "Suggested Mentors",
  },
  {
    path: "/dashboard-mentors",
    name: "MentorsListing",
    component: MentorListing,
    title: "MentorsListing",
  },
  {
    path: "/mentees-listing",
    name: "MenteeListing",
    component: MenteeListing,
    title: "MenteeListing",
  },
  {
    path: "/manage-profile",
    name: "ManageProfile",
    component: UpdateProfile,
    title: "ManageProfile",
  },



  {
    path: "/manage-profile-step1",
    name: "ManageProfile-Step1",
    component: updateProfile12,
    title: "ManageProfile Step1",
  },


  {
    path: "/manage-profile-step2",
    name: "ManageProfile-Step2",
    component: UpdateProfile2,
    title: "ManageProfile-Step2",
  },
  {
    path: "/manage-profile-step3",
    name: "ManageProfile-Step3",
    component: UpdateProfile3,
    title: "ManageProfile-Step3",
  },
  {
    path: "/manage-profile-step4",
    name: "ManageProfile-Step4",
    component: UpdateProfile4,
    title: "ManageProfile-Step4",
  },
  {
    path: "/change-password",
    name: "change-password",
    component: Password,
    title: "change-password",
  },
  {
    path: "/mentees-request",
    name: "mentees-request",
    component: MenteeRequest,
    title: "mentees-request",
  },
  {
    path: "/my-mentors",
    name: "my-mentors",
    component: MyMentors,
    title: "my-mentors",
  },
  {
    path: "/my-waitlist",
    name: "my-waitlist",
    component: MyWaitList,
    title: "my-waitlist",
  },
  {
    path: "/pending-mentors",
    name: "pending-mentors",
    component: PendingMenterRequest,
    title: "pending-mentors",
  },
  {
    path: "/mentees-logs",
    name: "mentees-logs",
    component: MenteesLog,
    title: "mentees-logs",
  },
  {
    path: "/my-diagnostic-toolkit",
    name: "my-diagnostic-toolkit",
    component: MyDiagnosticToolkit,
    title: "Goal Setting",
  },
  {
    path: "/certificate",
    name: "certificate",
    component: Certificate,
    title: "Certificate",
  },
  {
    path: "/availability",
    name: "Availability",
    component: Availability,
    title: "Availability",
  },
  {
    path: "/chat",
    name: "Chat",
    component: Chat,
    title: "Chat",
  },
  {
    path: "/delete-my-profile",
    name: "DeleteProfile",
    component: DeleteProfile,
    title: "Delete Profile",
  },
  {
    path: "/refer",
    name: "Refer",
    component: Refer,
    title: "Refer vLookUp",
  },
  {
    path: "/forum",
    name: "Forum",
    component: Forum,
    title: "Forum",
  },
  {
    path: "/forumtest",
    name: "Forum",
    component: ForumTest,
    title: "Forum",
  },
];
